
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"6","height":"32","viewBox":"0 0 6 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"1","cy":"1","r":"1","fill":"#AAACB0"}}),_c('circle',{attrs:{"cx":"1","cy":"7","r":"1","fill":"#AAACB0"}}),_c('circle',{attrs:{"cx":"1","cy":"13","r":"1","fill":"#AAACB0"}}),_c('circle',{attrs:{"cx":"1","cy":"19","r":"1","fill":"#AAACB0"}}),_c('circle',{attrs:{"cx":"1","cy":"25","r":"1","fill":"#AAACB0"}}),_c('circle',{attrs:{"cx":"1","cy":"31","r":"1","fill":"#AAACB0"}}),_c('circle',{attrs:{"cx":"5","cy":"1","r":"1","fill":"#AAACB0"}}),_c('circle',{attrs:{"cx":"5","cy":"7","r":"1","fill":"#AAACB0"}}),_c('circle',{attrs:{"cx":"5","cy":"13","r":"1","fill":"#AAACB0"}}),_c('circle',{attrs:{"cx":"5","cy":"19","r":"1","fill":"#AAACB0"}}),_c('circle',{attrs:{"cx":"5","cy":"25","r":"1","fill":"#AAACB0"}}),_c('circle',{attrs:{"cx":"5","cy":"31","r":"1","fill":"#AAACB0"}})])
          )
        }
      }
    